// Function that should handle the "debug" state of *any* fandom application using these tools
// right now it's limited to silversurfer ss_debug=true
export function isDebug() {
    return isSilverSurferDebug() || isLocalHost();
}
export function isSilverSurferDebug() {
    return !!window.location.search.includes('ss_debug');
}
export const isLocalHost = () => /^localhost/.test(location.hostname) || location.hostname === '127.0.0.1';
